
import React from "react";
import { Schemes } from "../../../../../../utils";
import { i18nManager } from "../../../../../../i18n";
import { Elements } from "../../../../../shared/Elements";
import { Button, Checkbox, Classname, Form } from "@rivtn/noseur";
import { BaseService, IMember, ITournamentEdition, ITournamentEditionWebsite, SanitizedResponse, TournamentService } from "../../../../../../services";
import { Siren } from "../../../../../shared/ConfirmDialog";

export interface LeaderboardProps {
    profile: IMember;
    tournamentEdition: ITournamentEdition;
    tournamentEditionWebsite: ITournamentEditionWebsite;
}

function Leaderboard(props: LeaderboardProps) {

    const { tournamentEdition } = props;
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.settings.leaderboard;
    const [tournamentEditionWebsite, setTournamentEditionWebsite] = React.useState<ITournamentEditionWebsite>(props.tournamentEditionWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className={Classname.build("profile-settings", "team-settings")}>
        <Checkbox label={labels.enable_ad} defaultChecked={tournamentEditionWebsite?.leaderboard_settings?.enable_rivtn_ad} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, leaderboard_settings: { ...tournamentEditionWebsite.leaderboard_settings, enable_rivtn_ad: e.checked } });
        }} />
        <hr />
        <Checkbox label={labels.show_form} defaultChecked={tournamentEditionWebsite?.leaderboard_settings?.show_participants_form} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, leaderboard_settings: { ...tournamentEditionWebsite.leaderboard_settings, show_participants_form: e.checked } })
        }} />
        <Checkbox label={labels.show_wld_records} defaultChecked={tournamentEditionWebsite?.leaderboard_settings?.show_participants_wld_record} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, leaderboard_settings: { ...tournamentEditionWebsite.leaderboard_settings, show_participants_wld_record: e.checked } })
        }} />
        <Checkbox label={labels.show_all_custom_scores} defaultChecked={tournamentEditionWebsite?.leaderboard_settings?.show_all_custom_score_leaderboard} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, leaderboard_settings: { ...tournamentEditionWebsite.leaderboard_settings, show_all_custom_score_leaderboard: e.checked } })
        }} />
        <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.save_changes} loadingProps={Elements.BUTTON_LOADING_PROPS}
            style={{ marginTop: 20 }} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                updateWebsite(() => e.manageRef?.setLoadingState(false));
            }} />
    </Form>);

    function updateWebsite(onDone?: () => void) {
        tournamentService.updateTournamentEditionWebsite(tournamentEdition.external_id, tournamentEditionWebsite!).then(({ sanitized }: SanitizedResponse<ITournamentEditionWebsite>) => {
            setTournamentEditionWebsite(sanitized);
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Leaderboard;
